// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"8fe2ea71","252":"a7dd5256","346":"30e14600","361":"5b2d2d30","427":"d9f591be","437":"e8d8cd18","507":"5b2d2d30","520":"5f362f4d","582":"8f1d5409","729":"749566bb","947":"be77114e"}[chunkId] + ".chunk.css";
};